export default "__VITE_ASSET__8e45bddf__"